module.exports = __webpack_public_path__ + "static/media/Asset 1.1b05bca9.png";